import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push, replace } from 'react-router-redux';
import './HomePage.scss';
import PCView from './PCView';
import Mobile from './Mobile';
import { Toast } from 'antd-mobile';
import { flushCurrency } from '../../../redux/modules/flush';
import { getSupportedChains } from '../../../redux/modules/chains';
import { showSucceedDialog, showFailedDialog  } from '../../../redux/modules/dialog';
import { toLowerCaseEquals } from '../../../helpers/Utils';

const mapActionCreators = {
  push,
  replace,
  flushCurrency,
  getSupportedChains,
  showSucceedDialog,
  showFailedDialog
};

const mapStateToProps = (state, ownProps) => {
  return {
    device: state.device.current,
    flushLoading : state.flush.flushLoading,
    flushLoaded : state.flush.flushLoaded,
    flushError : state.flush.flushError,
    flushData : state.flush.flushData,
    flushErrorMsg : state.flush.flushErrorMsg,

    chainsLoading : state.chains.chainsLoading,
    chainsLoaded : state.chains.chainsLoaded,
    chainsError : state.chains.chainsError,
    chainsData : state.chains.chainsData,
    chainsErrorMsg : state.chains.chainsErrorMsg,
  }
};

class HomePage extends Component {

  state = {
    tabIndex: 0,
    defaultIndex: -1,
    chainList:[]
  }


  componentWillMount() {
    this.props.getSupportedChains();
  }

  componentDidMount() {
  }

  componentWillReceiveProps(newProps) {
    if(this.props.flushLoaded !== newProps.flushLoaded && newProps.flushLoaded){
      console.log('flushLoaded')
      // 设置短暂延迟，确保Toast显示足够的时间
      setTimeout(() => {
        Toast.hide();
        this.props.showSucceedDialog();
      }, 300);
    }
    if(this.props.flushError !== newProps.flushError && newProps.flushError){
      console.log('flushError')
      // 设置短暂延迟，确保Toast显示足够的时间
      setTimeout(() => {
        Toast.hide();
        this.props.showFailedDialog();
      }, 300);
    }
    if(this.props.chainsLoaded !== newProps.chainsLoaded && newProps.chainsLoaded) {
      let list = newProps.chainsData;
      let defaultIndex = 0;
      list = list.sort((a, b) => {
        return a.name > b.name ? 1 : -1;
      })
      for(let i = 0; i < list.length; i ++) {
        if(toLowerCaseEquals(list[i].name, 'bsc')){
          defaultIndex = i;
        }
      }
      this.setState({chainList: list, defaultIndex});
    }
  }

  componentWillUnmount() {
  }

  onCommit = (selectedChain, address) => {
    if(!address){
      Toast.info('请输入代币合约地址', 2, null, false);
      return;
    }
    // 确保先显示Toast，再发起请求
    Toast.hide(); // 先隐藏可能存在的其他Toast
    Toast.loading('数据请求中...', 60, null, true);
    setTimeout(() => {
      this.props.flushCurrency(selectedChain.id, address);
    }, 100); // 短暂延迟，确保Toast显示
  }

  render = () => {
    const { device } = this.props;
    const { chainList, defaultIndex } = this.state;
    return <div className='page_container'>
      {device === 'pc' && <PCView
        chainList={chainList}
        defaultIndex={defaultIndex}
        onCommit={this.onCommit}
      />}
      {device !== 'pc' && <Mobile
        defaultIndex={defaultIndex}
        chainList={chainList}
        onCommit={this.onCommit}
      />}
    </div>
  }
}

export default connect(mapStateToProps, mapActionCreators)(HomePage);
